const PdfFiles =

  [


    {
      "id": "slbphy27",
      "name": "syllabus-physics",
      "type": "syllabus",
      "subject": "physics",
      "topic": "SP",
      "pdfPath": "slbphy27.pdf"
    },
    {
      "id": "slbche27",
      "name": "syllabus-chemistry",
      "type": "syllabus",
      "subject": "chemistry",
      "topic": "SC",
      "pdfPath": "slbche27.pdf"
    },
    {
      "id": "slbbio27",
      "name": "syllabus-biology",
      "type": "syllabus",
      "subject": "biology",
      "topic": "SB",
      "pdfPath": "slbbio27.pdf"
    },


    {
    "id": "ncertbookphy1",
    "name": "1-UNITS AND MEASUREMENT",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pdfPath": "ncertbookphy1.pdf"
  },
  {
    "id": "ncertbookphy2",
    "name": "2-MOTION IN A STRAIGHT LINE",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pdfPath": "ncertbookphy2.pdf"
  },
  {
    "id": "ncertbookphy3",
    "name": "3-MOTION IN A PLANE",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pdfPath": "ncertbookphy3.pdf"
  },
  {
    "id": "ncertbookphy4",
    "name": "4-LAWS OF MOTION",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pdfPath": "ncertbookphy4.pdf"
  },
  {
    "id": "ncertbookphy5",
    "name": "5-WORK, ENERGY AND POWER",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pdfPath": "ncertbookphy5.pdf"
  },
  {
    "id": "ncertbookphy6",
    "name": "6-SYSTEMS OF PARTICLES AND ROTATIONAL MOTION",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pdfPath": "ncertbookphy6.pdf"
  },
  {
    "id": "ncertbookphy7",
    "name": "7-GRAVITATION",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pdfPath": "ncertbookphy7.pdf"
  },
  {
    "id": "ncertbookphy8",
    "name": "8-MECHANICAL PROPERTIES OF SOLIDS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pdfPath": "ncertbookphy8.pdf"
  },
  {
    "id": "ncertbookphy9",
    "name": "9-MECHANICAL PROPERTIES OF FLUIDS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pdfPath": "ncertbookphy9.pdf"
  },
  {
    "id": "ncertbookphy10",
    "name": "10-THERMAL PROPERTIES OF MATTER",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pdfPath": "ncertbookphy10.pdf"
  },
  {
    "id": "ncertbookphy11",
    "name": "11-THERMODYNAMICS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pdfPath": "ncertbookphy11.pdf"
  },
  {
    "id": "ncertbookphy12",
    "name": "12-KINETIC THEORY",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pdfPath": "ncertbookphy12.pdf"
  },
  {
    "id": "ncertbookphy13",
    "name": "13-OSCILLATIONS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pdfPath": "ncertbookphy13.pdf"
  },
  {
    "id": "ncertbookphy14",
    "name": "14-WAVES",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pdfPath": "ncertbookphy14.pdf"
  },
  {
    "id": "ncertbookphy15",
    "name": "1-ELECTRIC CHARGES AND FIELDS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pdfPath": "ncertbookphy15.pdf"
  },
  {
    "id": "ncertbookphy16",
    "name": "2-ELECTROSTATIC POTENTIAL AND CAPACITANCE",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pdfPath": "ncertbookphy16.pdf"
  },
  {
    "id": "ncertbookphy17",
    "name": "3-CURRENT ELECTRICITY",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pdfPath": "ncertbookphy17.pdf"
  },
  {
    "id": "ncertbookphy18",
    "name": "4-MOVING CHARGES AND MAGNETISM",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pdfPath": "ncertbookphy18.pdf"
  },
  {
    "id": "ncertbookphy19",
    "name": "5-MAGNETISM AND MATTER",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pdfPath": "ncertbookphy19.pdf"
  },
  {
    "id": "ncertbookphy20",
    "name": "6-ELECTROMAGNETIC INDUCTION",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pdfPath": "ncertbookphy20.pdf"
  },
  {
    "id": "ncertbookphy21",
    "name": "7-ALTERNATING CURRENT",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pdfPath": "ncertbookphy21.pdf"
  },
  {
    "id": "ncertbookphy22",
    "name": "8-ELECTROMAGNETIC WAVES",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pdfPath": "ncertbookphy22.pdf"
  },
  {
    "id": "ncertbookphy23",
    "name": "9-RAY OPTICS AND OPTICAL INSTRUMENTS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pdfPath": "ncertbookphy23.pdf"
  },
  {
    "id": "ncertbookphy24",
    "name": "10-WAVE OPTICS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pdfPath": "ncertbookphy24.pdf"
  },
  {
    "id": "ncertbookphy25",
    "name": "11-DUAL NATURE OF RADIATION AND MATTER",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pdfPath": "ncertbookphy25.pdf"
  },
  {
    "id": "ncertbookphy26",
    "name": "12-ATOMS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pdfPath": "ncertbookphy26.pdf"
  },
  {
    "id": "ncertbookphy27",
    "name": "13-NUCLEI",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pdfPath": "ncertbookphy27.pdf"
  },
  {
    "id": "ncertbookphy28",
    "name": "14-SEMICONDUCTOR ELECTRONICS",
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pdfPath": "ncertbookphy28.pdf"
  },
{
    "id": "ncertbookche1",
    "name": "1-SOME BASIC CONCEPTS OF CHEMISTRY",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pdfPath": "ncertbookche1.pdf"
  },
  {
    "id": "ncertbookche2",
    "name": "2-STRUCTURE OF ATOM",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pdfPath": "ncertbookche2.pdf"
  },
  {
    "id": "ncertbookche3",
    "name": "3-CLASSIFICATION OF ELEMENTS AND PERIODICITY",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pdfPath": "ncertbookche3.pdf"
  },
  {
    "id": "ncertbookche4",
    "name": "4-CHEMICAL BONDING AND MOLECULAR STRUCTURE",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pdfPath": "ncertbookche4.pdf"
  },
  {
    "id": "ncertbookche5",
    "name": "5-THERMODYNAMICS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pdfPath": "ncertbookche5.pdf"
  },
  {
    "id": "ncertbookche6",
    "name": "6-EQUILIBRIUM",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pdfPath": "ncertbookche6.pdf"
  },
  {
    "id": "ncertbookche7",
    "name": "7-REDOX REACTIONS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pdfPath": "ncertbookche7.pdf"
  },
  {
    "id": "ncertbookche8",
    "name": "8-ORGANIC CHEMISTRY – SOME BASIC PRINCIPLES",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pdfPath": "ncertbookche8.pdf"
  },
  {
    "id": "ncertbookche9",
    "name": "9-HYDROCARBONS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pdfPath": "ncertbookche9.pdf"
  },
  {
    "id": "ncertbookche10",
    "name": "1-SOLUTIONS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pdfPath": "ncertbookche10.pdf"
  },
  {
    "id": "ncertbookche11",
    "name": "2-ELECTROCHEMISTRY",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pdfPath": "ncertbookche11.pdf"
  },
  {
    "id": "ncertbookche12",
    "name": "3-CHEMICAL KINETICS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pdfPath": "ncertbookche12.pdf"
  },
  {
    "id": "ncertbookche13",
    "name": "4-D AND F BLOCK ELEMENTS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pdfPath": "ncertbookche13.pdf"
  },
  {
    "id": "ncertbookche14",
    "name": "5-COORDINATION COMPOUNDS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pdfPath": "ncertbookche14.pdf"
  },
  {
    "id": "ncertbookche15",
    "name": "6-HALOALKANES AND HALOARENES",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pdfPath": "ncertbookche15.pdf"
  },
  {
    "id": "ncertbookche16",
    "name": "7-ALCOHOLS, PHENOLS AND ETHERS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pdfPath": "ncertbookche16.pdf"
  },
  {
    "id": "ncertbookche17",
    "name": "8-ALDEHYDES, KETONES AND CARBOXYLIC ACIDS",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pdfPath": "ncertbookche17.pdf"
  },
  {
    "id": "ncertbookche18",
    "name": "9-AMINES",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pdfPath": "ncertbookche18.pdf"
  },
  {
    "id": "ncertbookche19",
    "name": "10-BIOMOLECULES",
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pdfPath": "ncertbookche19.pdf"
  },
{
    "id": "ncertbookbio1",
    "name": "1-THE LIVING WORLD",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pdfPath": "ncertbookbio1.pdf"
  },
  {
    "id": "ncertbookbio2",
    "name": "2-BIOLOGICAL CLASSIFICATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pdfPath": "ncertbookbio2.pdf"
  },
  {
    "id": "ncertbookbio3",
    "name": "3-PLANT KINGDOM",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pdfPath": "ncertbookbio3.pdf"
  },
  {
    "id": "ncertbookbio4",
    "name": "4-ANIMAL KINGDOM",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pdfPath": "ncertbookbio4.pdf"
  },
  {
    "id": "ncertbookbio5",
    "name": "5-MORPHOLOGY OF FLOWERING PLANTS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pdfPath": "ncertbookbio5.pdf"
  },
  {
    "id": "ncertbookbio6",
    "name": "6-ANATOMY OF FLOWERING PLANTS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pdfPath": "ncertbookbio6.pdf"
  },
  {
    "id": "ncertbookbio7",
    "name": "7-STRUCTURAL ORGANIZATION IN ANIMALS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pdfPath": "ncertbookbio7.pdf"
  },
  {
    "id": "ncertbookbio8",
    "name": "8-CELL: THE UNIT OF LIFE",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pdfPath": "ncertbookbio8.pdf"
  },
  {
    "id": "ncertbookbio9",
    "name": "9-BIOMOLECULES",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pdfPath": "ncertbookbio9.pdf"
  },
  {
    "id": "ncertbookbio10",
    "name": "10-CELL CYCLE AND CELL DIVISION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pdfPath": "ncertbookbio10.pdf"
  },
  {
    "id": "ncertbookbio11",
    "name": "11-PHOTOSYNTHESIS IN HIGHER PLANTS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pdfPath": "ncertbookbio11.pdf"
  },
  {
    "id": "ncertbookbio12",
    "name": "12-RESPIRATION IN PLANTS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pdfPath": "ncertbookbio12.pdf"
  },
  {
    "id": "ncertbookbio13",
    "name": "13-PLANT GROWTH AND DEVELOPMENT",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pdfPath": "ncertbookbio13.pdf"
  },
  {
    "id": "ncertbookbio14",
    "name": "14-BREATHING AND EXCHANGE OF GASES",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pdfPath": "ncertbookbio14.pdf"
  },
  {
    "id": "ncertbookbio15",
    "name": "15-BODY FLUIDS AND CIRCULATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pdfPath": "ncertbookbio15.pdf"
  },
  {
    "id": "ncertbookbio16",
    "name": "16-EXCRETORY PRODUCTS AND THEIR ELIMINATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pdfPath": "ncertbookbio16.pdf"
  },
  {
    "id": "ncertbookbio17",
    "name": "17-LOCOMOTION AND MOVEMENT",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pdfPath": "ncertbookbio17.pdf"
  },
  {
    "id": "ncertbookbio18",
    "name": "18-NEURAL CONTROL AND COORDINATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pdfPath": "ncertbookbio18.pdf"
  },
  {
    "id": "ncertbookbio19",
    "name": "19-CHEMICAL COORDINATION AND INTEGRATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pdfPath": "ncertbookbio19.pdf"
  },
  {
    "id": "ncertbookbio20",
    "name": "1-SEXUAL REPRODUCTION IN FLOWERING PLANTS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pdfPath": "ncertbookbio20.pdf"
  },
  {
    "id": "ncertbookbio21",
    "name": "2-HUMAN REPRODUCTION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pdfPath": "ncertbookbio21.pdf"
  },
  {
    "id": "ncertbookbio22",
    "name": "3-REPRODUCTIVE HEALTH",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pdfPath": "ncertbookbio22.pdf"
  },
  {
    "id": "ncertbookbio23",
    "name": "4-PRINCIPLES OF INHERITANCE AND VARIATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pdfPath": "ncertbookbio23.pdf"
  },
  {
    "id": "ncertbookbio24",
    "name": "5-MOLECULAR BASIS OF INHERITANCE",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pdfPath": "ncertbookbio24.pdf"
  },
  {
    "id": "ncertbookbio25",
    "name": "6-EVOLUTION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pdfPath": "ncertbookbio25.pdf"
  },
  {
    "id": "ncertbookbio26",
    "name": "7-HUMAN HEALTH AND DISEASE",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pdfPath": "ncertbookbio26.pdf"
  },
  {
    "id": "ncertbookbio27",
    "name": "8-MICROBES IN HUMAN WELFARE",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pdfPath": "ncertbookbio27.pdf"
  },
  {
    "id": "ncertbookbio28",
    "name": "9-BIOTECHNOLOGY: PRINCIPLES AND PROCESSES",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pdfPath": "ncertbookbio28.pdf"
  },
  {
    "id": "ncertbookbio29",
    "name": "10-BIOTECHNOLOGY AND ITS APPLICATIONS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pdfPath": "ncertbookbio29.pdf"
  },
  {
    "id": "ncertbookbio30",
    "name": "11-ORGANISMS AND POPULATIONS",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pdfPath": "ncertbookbio30.pdf"
  },
  {
    "id": "ncertbookbio31",
    "name": "12-ECOSYSTEM",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pdfPath": "ncertbookbio31.pdf"
  },
  {
    "id": "ncertbookbio32",
    "name": "13-BIODIVERSITY AND CONSERVATION",
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pdfPath": "ncertbookbio32.pdf"
  },
{
    "id": "ncertshortnotephy1",
    "name": "1-UNIT AND DIMENSIONS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP01",
    "pdfPath": "ncertshortnotephy1.pdf"
  },
  {
    "id": "ncertshortnotephy2",
    "name": "2-RECTILINEAR MOTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP02",
    "pdfPath": "ncertshortnotephy2.pdf"
  },
  {
    "id": "ncertshortnotephy3",
    "name": "3-PROJECTILE MOTION & VECTORS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP03",
    "pdfPath": "ncertshortnotephy3.pdf"
  },
  {
    "id": "ncertshortnotephy4",
    "name": "4-RELATIVE MOTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP04",
    "pdfPath": "ncertshortnotephy4.pdf"
  },
  {
    "id": "ncertshortnotephy5",
    "name": "5-NEWTON'S LAWS OF MOTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP05",
    "pdfPath": "ncertshortnotephy5.pdf"
  },
  {
    "id": "ncertshortnotephy6",
    "name": "6-FRICTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP06",
    "pdfPath": "ncertshortnotephy6.pdf"
  },
  {
    "id": "ncertshortnotephy7",
    "name": "7-WORK, POWER & ENERGY",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP07",
    "pdfPath": "ncertshortnotephy7.pdf"
  },
  {
    "id": "ncertshortnotephy8",
    "name": "8-CIRCULAR MOTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP08",
    "pdfPath": "ncertshortnotephy8.pdf"
  },
  {
    "id": "ncertshortnotephy9",
    "name": "9-CENTRE OF MASS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP09",
    "pdfPath": "ncertshortnotephy9.pdf"
  },
  {
    "id": "ncertshortnotephy10",
    "name": "10-RIGID BODY DYNAMICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP10",
    "pdfPath": "ncertshortnotephy10.pdf"
  },
  {
    "id": "ncertshortnotephy11",
    "name": "11-SIMPLE HARMONIC MOTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP11",
    "pdfPath": "ncertshortnotephy11.pdf"
  },
  {
    "id": "ncertshortnotephy12",
    "name": "12-STRING WAVES",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP12",
    "pdfPath": "ncertshortnotephy12.pdf"
  },
  {
    "id": "ncertshortnotephy13",
    "name": "13-HEAT & THERMODYNAMICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP13",
    "pdfPath": "ncertshortnotephy13.pdf"
  },
  {
    "id": "ncertshortnotephy14",
    "name": "14-CURRENT ELECTRICITY",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP14",
    "pdfPath": "ncertshortnotephy14.pdf"
  },
  {
    "id": "ncertshortnotephy15",
    "name": "15-CAPACITANCE",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP15",
    "pdfPath": "ncertshortnotephy15.pdf"
  },
  {
    "id": "ncertshortnotephy16",
    "name": "16-ALTERNATING CURRENT",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP16",
    "pdfPath": "ncertshortnotephy16.pdf"
  },
  {
    "id": "ncertshortnotephy17",
    "name": "17-MAGNETIC EFFECT OF CURRENT",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP17",
    "pdfPath": "ncertshortnotephy17.pdf"
  },
  {
    "id": "ncertshortnotephy18",
    "name": "18-ELECTROMAGNETIC INDUCTION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP18",
    "pdfPath": "ncertshortnotephy18.pdf"
  },
  {
    "id": "ncertshortnotephy19",
    "name": "19-GEOMETRICAL OPTICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP19",
    "pdfPath": "ncertshortnotephy19.pdf"
  },
  {
    "id": "ncertshortnotephy20",
    "name": "20-MODERN PHYSICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP20",
    "pdfPath": "ncertshortnotephy20.pdf"
  },
  {
    "id": "ncertshortnotephy21",
    "name": "21-WAVE OPTICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP21",
    "pdfPath": "ncertshortnotephy21.pdf"
  },
  {
    "id": "ncertshortnotephy22",
    "name": "22-GRAVITATION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP22",
    "pdfPath": "ncertshortnotephy22.pdf"
  },
  {
    "id": "ncertshortnotephy23",
    "name": "23-FLUID MECHANICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP23",
    "pdfPath": "ncertshortnotephy23.pdf"
  },
  {
    "id": "ncertshortnotephy24",
    "name": "24-SOUND WAVES",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP24",
    "pdfPath": "ncertshortnotephy24.pdf"
  },
  {
    "id": "ncertshortnotephy25",
    "name": "25-ELECTROMAGNETIC WAVES",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP25",
    "pdfPath": "ncertshortnotephy25.pdf"
  },
  {
    "id": "ncertshortnotephy26",
    "name": "26-ERROR AND MEASUREMENT",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP26",
    "pdfPath": "ncertshortnotephy26.pdf"
  },
  {
    "id": "ncertshortnotephy27",
    "name": "27-PRINCIPLE OF COMMUNICATION",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP27",
    "pdfPath": "ncertshortnotephy27.pdf"
  },
  {
    "id": "ncertshortnotephy28",
    "name": "28-SEMICONDUCTOR",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP28",
    "pdfPath": "ncertshortnotephy28.pdf"
  },
  {
    "id": "ncertshortnotephy29",
    "name": "29-ELECTROSTATICS",
    "type": "ncertshortnote",
    "subject": "physics",
    "topic": "CP29",
    "pdfPath": "ncertshortnotephy29.pdf"
  },
{
    "id": "ncertshortnoteche1",
    "name": "1-ATOMIC STRUCTURE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC01",
    "pdfPath": "ncertshortnoteche1.pdf"
  },
  {
    "id": "ncertshortnoteche2",
    "name": "2-STOICHIOMETRY",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC02",
    "pdfPath": "ncertshortnoteche2.pdf"
  },
  {
    "id": "ncertshortnoteche3",
    "name": "3-GASEOUS STATE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC03",
    "pdfPath": "ncertshortnoteche3.pdf"
  },
  {
    "id": "ncertshortnoteche4",
    "name": "4-THERMODYNAMICS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC04",
    "pdfPath": "ncertshortnoteche4.pdf"
  },
  {
    "id": "ncertshortnoteche5",
    "name": "5-CHEMICAL EQUILIBRIUM",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC05",
    "pdfPath": "ncertshortnoteche5.pdf"
  },
  {
    "id": "ncertshortnoteche6",
    "name": "6-IONIC EQUILIBRIUM",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC06",
    "pdfPath": "ncertshortnoteche6.pdf"
  },
  {
    "id": "ncertshortnoteche7",
    "name": "7-ELECTROCHEMISTRY",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC07",
    "pdfPath": "ncertshortnoteche7.pdf"
  },
  {
    "id": "ncertshortnoteche8",
    "name": "8-SOLUTION & COLLIGATIVE PROPERTIES",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC08",
    "pdfPath": "ncertshortnoteche8.pdf"
  },
  {
    "id": "ncertshortnoteche9",
    "name": "9-SOLID STATE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC09",
    "pdfPath": "ncertshortnoteche9.pdf"
  },
  {
    "id": "ncertshortnoteche10",
    "name": "10-CHEMICAL KINETICS & RADIOACTIVITY",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC10",
    "pdfPath": "ncertshortnoteche10.pdf"
  },
  {
    "id": "ncertshortnoteche11",
    "name": "11-PERIODIC TABLE & PERIODICITY",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC11",
    "pdfPath": "ncertshortnoteche11.pdf"
  },
  {
    "id": "ncertshortnoteche12",
    "name": "12-CHEMICAL BONDING",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC12",
    "pdfPath": "ncertshortnoteche12.pdf"
  },
  {
    "id": "ncertshortnoteche13",
    "name": "13-COORDINATION COMPOUNDS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC13",
    "pdfPath": "ncertshortnoteche13.pdf"
  },
  {
    "id": "ncertshortnoteche14",
    "name": "14-METALLURGY",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC14",
    "pdfPath": "ncertshortnoteche14.pdf"
  },
  {
    "id": "ncertshortnoteche15",
    "name": "15-S-BLOCK ELEMENTS & THEIR COMPOUNDS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC15",
    "pdfPath": "ncertshortnoteche15.pdf"
  },
  {
    "id": "ncertshortnoteche16",
    "name": "16-P-BLOCK ELEMENTS & THEIR COMPOUNDS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC16",
    "pdfPath": "ncertshortnoteche16.pdf"
  },
  {
    "id": "ncertshortnoteche17",
    "name": "17-D-BLOCK ELEMENTS & THEIR COMPOUNDS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC17",
    "pdfPath": "ncertshortnoteche17.pdf"
  },
  {
    "id": "ncertshortnoteche18",
    "name": "18-QUALITATIVE ANALYSIS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC18",
    "pdfPath": "ncertshortnoteche18.pdf"
  },
  {
    "id": "ncertshortnoteche19",
    "name": "19-NOMENCLATURE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC19",
    "pdfPath": "ncertshortnoteche19.pdf"
  },
  {
    "id": "ncertshortnoteche20",
    "name": "20-STRUCTURAL ISOMERISM",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC20",
    "pdfPath": "ncertshortnoteche20.pdf"
  },
  {
    "id": "ncertshortnoteche21",
    "name": "21-GENERAL ORGANIC CHEMISTRY",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC21",
    "pdfPath": "ncertshortnoteche21.pdf"
  },
  {
    "id": "ncertshortnoteche22",
    "name": "22-ALKANE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC22",
    "pdfPath": "ncertshortnoteche22.pdf"
  },
  {
    "id": "ncertshortnoteche23",
    "name": "23-ALKENE & ALKYNE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC23",
    "pdfPath": "ncertshortnoteche23.pdf"
  },
  {
    "id": "ncertshortnoteche24",
    "name": "24-ALKYL HALIDE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC24",
    "pdfPath": "ncertshortnoteche24.pdf"
  },
  {
    "id": "ncertshortnoteche25",
    "name": "25-ALCOHOL",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC25",
    "pdfPath": "ncertshortnoteche25.pdf"
  },
  {
    "id": "ncertshortnoteche26",
    "name": "26-GRIGNARD REAGENTS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC26",
    "pdfPath": "ncertshortnoteche26.pdf"
  },
  {
    "id": "ncertshortnoteche27",
    "name": "27-REDUCTION",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC27",
    "pdfPath": "ncertshortnoteche27.pdf"
  },
  {
    "id": "ncertshortnoteche28",
    "name": "28-OXIDATION REACTION",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC28",
    "pdfPath": "ncertshortnoteche28.pdf"
  },
  {
    "id": "ncertshortnoteche29",
    "name": "29-ALDEHYDE & KETONE",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC29",
    "pdfPath": "ncertshortnoteche29.pdf"
  },
  {
    "id": "ncertshortnoteche30",
    "name": "30-CARBOXYLIC ACID & DERIVATIVES",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC30",
    "pdfPath": "ncertshortnoteche30.pdf"
  },
  {
    "id": "ncertshortnoteche31",
    "name": "31-AROMATIC COMPOUNDS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC31",
    "pdfPath": "ncertshortnoteche31.pdf"
  },
  {
    "id": "ncertshortnoteche32",
    "name": "32-POLYMERS",
    "type": "ncertshortnote",
    "subject": "chemistry",
    "topic": "CC32",
    "pdfPath": "ncertshortnoteche32.pdf"
  },
{
    "id": "ncertshortnotebio1",
    "name": "1-HUMAN HEALTH AND DISEASES",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB01",
    "pdfPath": "ncertshortnotebio1.pdf"
  },
  {
    "id": "ncertshortnotebio2",
    "name": "2-HUMAN REPRODUCTION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB02",
    "pdfPath": "ncertshortnotebio2.pdf"
  },
  {
    "id": "ncertshortnotebio3",
    "name": "3-BIOTECHNOLOGY AND ITS APPLICATIONS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB03",
    "pdfPath": "ncertshortnotebio3.pdf"
  },
  {
    "id": "ncertshortnotebio4",
    "name": "4-ECOSYSTEM",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB04",
    "pdfPath": "ncertshortnotebio4.pdf"
  },
  {
    "id": "ncertshortnotebio5",
    "name": "5-BIOTECHNOLOGY: PRINCIPLES AND PROCESSES",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB05",
    "pdfPath": "ncertshortnotebio5.pdf"
  },
  {
    "id": "ncertshortnotebio6",
    "name": "6-REPRODUCTIVE HEALTH",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB06",
    "pdfPath": "ncertshortnotebio6.pdf"
  },
  {
    "id": "ncertshortnotebio7",
    "name": "7-BIODIVERSITY AND CONSERVATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB07",
    "pdfPath": "ncertshortnotebio7.pdf"
  },
  {
    "id": "ncertshortnotebio8",
    "name": "8-PRINCIPLES OF INHERITANCE AND VARIATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB08",
    "pdfPath": "ncertshortnotebio8.pdf"
  },
  {
    "id": "ncertshortnotebio9",
    "name": "9-BIOLOGICAL CLASSIFICATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB09",
    "pdfPath": "ncertshortnotebio9.pdf"
  },
  {
    "id": "ncertshortnotebio10",
    "name": "10-PLANT KINGDOM",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB10",
    "pdfPath": "ncertshortnotebio10.pdf"
  },
  {
    "id": "ncertshortnotebio11",
    "name": "11-ANIMAL KINGDOM",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB11",
    "pdfPath": "ncertshortnotebio11.pdf"
  },
  {
    "id": "ncertshortnotebio12",
    "name": "12-MORPHOLOGY OF FLOWERING PLANTS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB12",
    "pdfPath": "ncertshortnotebio12.pdf"
  },
  {
    "id": "ncertshortnotebio13",
    "name": "13-ANATOMY OF FLOWERING PLANTS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB13",
    "pdfPath": "ncertshortnotebio13.pdf"
  },
  {
    "id": "ncertshortnotebio14",
    "name": "14-STRUCTURAL ORGANISATION IN ANIMALS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB14",
    "pdfPath": "ncertshortnotebio14.pdf"
  },
  {
    "id": "ncertshortnotebio15",
    "name": "15-CELL: THE UNIT OF LIFE",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB15",
    "pdfPath": "ncertshortnotebio15.pdf"
  },
  {
    "id": "ncertshortnotebio16",
    "name": "16-CELL CYCLE AND CELL DIVISION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB16",
    "pdfPath": "ncertshortnotebio16.pdf"
  },
  {
    "id": "ncertshortnotebio17",
    "name": "17-BIOMOLECULES",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB17",
    "pdfPath": "ncertshortnotebio17.pdf"
  },
  {
    "id": "ncertshortnotebio18",
    "name": "18-TRANSPORT IN PLANTS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB18",
    "pdfPath": "ncertshortnotebio18.pdf"
  },
  {
    "id": "ncertshortnotebio19",
    "name": "19-MINERAL NUTRITION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB19",
    "pdfPath": "ncertshortnotebio19.pdf"
  },
  {
    "id": "ncertshortnotebio20",
    "name": "20-PHOTOSYNTHESIS IN HIGHER PLANTS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB20",
    "pdfPath": "ncertshortnotebio20.pdf"
  },
  {
    "id": "ncertshortnotebio21",
    "name": "21-RESPIRATION IN PLANTS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB21",
    "pdfPath": "ncertshortnotebio21.pdf"
  },
  {
    "id": "ncertshortnotebio22",
    "name": "22-PLANT GROWTH AND DEVELOPMENT",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB22",
    "pdfPath": "ncertshortnotebio22.pdf"
  },
  {
    "id": "ncertshortnotebio23",
    "name": "23-DIGESTION AND ABSORPTION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB23",
    "pdfPath": "ncertshortnotebio23.pdf"
  },
  {
    "id": "ncertshortnotebio24",
    "name": "24-BREATHING AND EXCHANGE OF GASES",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB24",
    "pdfPath": "ncertshortnotebio24.pdf"
  },
  {
    "id": "ncertshortnotebio25",
    "name": "25-BODY FLUIDS AND CIRCULATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB25",
    "pdfPath": "ncertshortnotebio25.pdf"
  },
  {
    "id": "ncertshortnotebio26",
    "name": "26-EXCRETORY PRODUCTS AND THEIR ELIMINATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB26",
    "pdfPath": "ncertshortnotebio26.pdf"
  },
  {
    "id": "ncertshortnotebio27",
    "name": "27-LOCOMOTION AND MOVEMENT",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB27",
    "pdfPath": "ncertshortnotebio27.pdf"
  },
  {
    "id": "ncertshortnotebio28",
    "name": "28-NEURAL CONTROL AND COORDINATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB28",
    "pdfPath": "ncertshortnotebio28.pdf"
  },
  {
    "id": "ncertshortnotebio29",
    "name": "29-CHEMICAL COORDINATION AND INTEGRATION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB29",
    "pdfPath": "ncertshortnotebio29.pdf"
  },
  {
    "id": "ncertshortnotebio30",
    "name": "30-REPRODUCTION IN ORGANISMS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB30",
    "pdfPath": "ncertshortnotebio30.pdf"
  },
  {
    "id": "ncertshortnotebio31",
    "name": "31-SEXUAL REPRODUCTION IN FLOWERING PLANTS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB31",
    "pdfPath": "ncertshortnotebio31.pdf"
  },
  {
    "id": "ncertshortnotebio32",
    "name": "32-THE LIVING WORLD",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB32",
    "pdfPath": "ncertshortnotebio32.pdf"
  },
  {
    "id": "ncertshortnotebio33",
    "name": "33-EVOLUTION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB33",
    "pdfPath": "ncertshortnotebio33.pdf"
  },
  {
    "id": "ncertshortnotebio34",
    "name": "34-MOLECULAR BASIS OF INHERITANCE",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB34",
    "pdfPath": "ncertshortnotebio34.pdf"
  },
  {
    "id": "ncertshortnotebio35",
    "name": "35-ORGANISMS AND POPULATIONS",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB35",
    "pdfPath": "ncertshortnotebio35.pdf"
  },
  {
    "id": "ncertshortnotebio36",
    "name": "36-STRATEGIES FOR ENHANCEMENT IN FOOD PRODUCTION",
    "type": "ncertshortnote",
    "subject": "biology",
    "topic": "CB36",
    "pdfPath": "ncertshortnotebio36.pdf"
  },

{
    "id": "ncertsolutionphy1",
    "name": "1 - PHYSICAL WORLD",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pdfPath": "ncertsolutionphy1.pdf"
  },
  {
    "id": "ncertsolutionphy2",
    "name": "2 - UNITS AND MEASUREMENT",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pdfPath": "ncertsolutionphy2.pdf"
  },
  {
    "id": "ncertsolutionphy3",
    "name": "3 - MOTION IN A STRAIGHT LINE",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pdfPath": "ncertsolutionphy3.pdf"
  },
  {
    "id": "ncertsolutionphy4",
    "name": "4 - MOTION IN A PLANE",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pdfPath": "ncertsolutionphy4.pdf"
  },
  {
    "id": "ncertsolutionphy5",
    "name": "5 - LAWS OF MOTION",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pdfPath": "ncertsolutionphy5.pdf"
  },
  {
    "id": "ncertsolutionphy6",
    "name": "6 - WORK, ENERGY AND POWER",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pdfPath": "ncertsolutionphy6.pdf"
  },
  {
    "id": "ncertsolutionphy7",
    "name": "7 - SYSTEMS OF PARTICLES AND ROTATIONAL MOTION",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pdfPath": "ncertsolutionphy7.pdf"
  },
  {
    "id": "ncertsolutionphy8",
    "name": "8 - GRAVITATION",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pdfPath": "ncertsolutionphy8.pdf"
  },
  {
    "id": "ncertsolutionphy9",
    "name": "9 - MECHANICAL PROPERTIES OF SOLIDS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pdfPath": "ncertsolutionphy9.pdf"
  },
  {
    "id": "ncertsolutionphy10",
    "name": "10 - MECHANICAL PROPERTIES OF FLUIDS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pdfPath": "ncertsolutionphy10.pdf"
  },
  {
    "id": "ncertsolutionphy11",
    "name": "11 - THERMAL PROPERTIES OF MATTER",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pdfPath": "ncertsolutionphy11.pdf"
  },
  {
    "id": "ncertsolutionphy12",
    "name": "12 - THERMODYNAMICS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pdfPath": "ncertsolutionphy12.pdf"
  },
  {
    "id": "ncertsolutionphy13",
    "name": "13 - KINETIC THEORY",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pdfPath": "ncertsolutionphy13.pdf"
  },
  {
    "id": "ncertsolutionphy14",
    "name": "14 - OSCILLATIONS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pdfPath": "ncertsolutionphy14.pdf"
  },
  {
    "id": "ncertsolutionphy15",
    "name": "15 - WAVES",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pdfPath": "ncertsolutionphy15.pdf"
  },
  {
    "id": "ncertsolutionphy16",
    "name": "16 - ELECTRIC CHARGES AND FIELDS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pdfPath": "ncertsolutionphy16.pdf"
  },
  {
    "id": "ncertsolutionphy17",
    "name": "17 - ELECTROSTATIC POTENTIAL AND CAPACITANCE",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pdfPath": "ncertsolutionphy17.pdf"
  },
  {
    "id": "ncertsolutionphy18",
    "name": "18 - CURRENT ELECTRICITY",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pdfPath": "ncertsolutionphy18.pdf"
  },
  {
    "id": "ncertsolutionphy19",
    "name": "19 - MOVING CHARGES AND MAGNETISM",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pdfPath": "ncertsolutionphy19.pdf"
  },
  {
    "id": "ncertsolutionphy20",
    "name": "20 - MAGNETISM AND MATTER",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pdfPath": "ncertsolutionphy20.pdf"
  },
  {
    "id": "ncertsolutionphy21",
    "name": "21 - ELECTROMAGNETIC INDUCTION",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pdfPath": "ncertsolutionphy21.pdf"
  },
  {
    "id": "ncertsolutionphy22",
    "name": "22 - ALTERNATING CURRENT",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pdfPath": "ncertsolutionphy22.pdf"
  },
  {
    "id": "ncertsolutionphy23",
    "name": "23 - ELECTROMAGNETIC WAVES",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pdfPath": "ncertsolutionphy23.pdf"
  },
  {
    "id": "ncertsolutionphy24",
    "name": "24 - RAY OPTICS AND OPTICAL INSTRUMENTS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pdfPath": "ncertsolutionphy24.pdf"
  },
  {
    "id": "ncertsolutionphy25",
    "name": "25 - WAVE OPTICS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pdfPath": "ncertsolutionphy25.pdf"
  },
  {
    "id": "ncertsolutionphy26",
    "name": "26 - DUAL NATURE OF RADIATION AND MATTER",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pdfPath": "ncertsolutionphy26.pdf"
  },
  {
    "id": "ncertsolutionphy27",
    "name": "27 - ATOMS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pdfPath": "ncertsolutionphy27.pdf"
  },
  {
    "id": "ncertsolutionphy28",
    "name": "28 - NUCLEI",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pdfPath": "ncertsolutionphy28.pdf"
  },
  {
    "id": "ncertsolutionphy29",
    "name": "29 - SEMICONDUCTOR ELECTRONICS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pdfPath": "ncertsolutionphy29.pdf"
  },
  {
    "id": "ncertsolutionphy30",
    "name": "30 - COMMUNICATION SYSTEMS",
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP30",
    "pdfPath": "ncertsolutionphy30.pdf"
  },
{
    "id": "ncertsolutionche1",
    "name": "1 - SOME BASIC CONCEPTS OF CHEMISTRY",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pdfPath": "ncertsolutionche1.pdf"
  },
  {
    "id": "ncertsolutionche2",
    "name": "2 - STRUCTURE OF ATOM",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pdfPath": "ncertsolutionche2.pdf"
  },
  {
    "id": "ncertsolutionche3",
    "name": "3 - CLASSIFICATION OF ELEMENTS AND PERIODICITY IN PROPERTIES",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pdfPath": "ncertsolutionche3.pdf"
  },
  {
    "id": "ncertsolutionche4",
    "name": "4 - CHEMICAL BONDING AND MOLECULAR STRUCTURE",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pdfPath": "ncertsolutionche4.pdf"
  },
  {
    "id": "ncertsolutionche5",
    "name": "5 - STATES OF MATTER",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pdfPath": "ncertsolutionche5.pdf"
  },
  {
    "id": "ncertsolutionche6",
    "name": "6 - THERMODYNAMICS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pdfPath": "ncertsolutionche6.pdf"
  },
  {
    "id": "ncertsolutionche7",
    "name": "7 - EQUILIBRIUM",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pdfPath": "ncertsolutionche7.pdf"
  },
  {
    "id": "ncertsolutionche8",
    "name": "8 - REDOX REACTIONS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pdfPath": "ncertsolutionche8.pdf"
  },
  {
    "id": "ncertsolutionche9",
    "name": "9 - HYDROGEN",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pdfPath": "ncertsolutionche9.pdf"
  },
  {
    "id": "ncertsolutionche10",
    "name": "10 - THE S-BLOCK ELEMENTS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pdfPath": "ncertsolutionche10.pdf"
  },
  {
    "id": "ncertsolutionche11",
    "name": "11 - THE P-BLOCK ELEMENTS (CLASS 11)",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pdfPath": "ncertsolutionche11.pdf"
  },
  {
    "id": "ncertsolutionche12",
    "name": "12 - ORGANIC CHEMISTRY: BASIC PRINCIPLES AND TECHNIQUES",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pdfPath": "ncertsolutionche12.pdf"
  },
  {
    "id": "ncertsolutionche13",
    "name": "13 - HYDROCARBONS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pdfPath": "ncertsolutionche13.pdf"
  },
  {
    "id": "ncertsolutionche14",
    "name": "14 - ENVIRONMENTAL CHEMISTRY",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pdfPath": "ncertsolutionche14.pdf"
  },
  {
    "id": "ncertsolutionche15",
    "name": "15 - THE SOLID STATE",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pdfPath": "ncertsolutionche15.pdf"
  },
  {
    "id": "ncertsolutionche16",
    "name": "16 - SOLUTIONS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pdfPath": "ncertsolutionche16.pdf"
  },
  {
    "id": "ncertsolutionche17",
    "name": "17 - ELECTROCHEMISTRY",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pdfPath": "ncertsolutionche17.pdf"
  },
  {
    "id": "ncertsolutionche18",
    "name": "18 - CHEMICAL KINETICS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pdfPath": "ncertsolutionche18.pdf"
  },
  {
    "id": "ncertsolutionche19",
    "name": "19 - SURFACE CHEMISTRY",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pdfPath": "ncertsolutionche19.pdf"
  },
  {
    "id": "ncertsolutionche20",
    "name": "20 - GENERAL PRINCIPLES AND PROCESSES OF ISOLATION OF ELEMENTS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pdfPath": "ncertsolutionche20.pdf"
  },
  {
    "id": "ncertsolutionche21",
    "name": "21 - THE P-BLOCK ELEMENTS (CLASS 12)",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pdfPath": "ncertsolutionche21.pdf"
  },
  {
    "id": "ncertsolutionche22",
    "name": "22 - THE D AND F BLOCK ELEMENTS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pdfPath": "ncertsolutionche22.pdf"
  },
  {
    "id": "ncertsolutionche23",
    "name": "23 - COORDINATION COMPOUNDS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pdfPath": "ncertsolutionche23.pdf"
  },
  {
    "id": "ncertsolutionche24",
    "name": "24 - HALOALKANES AND HALOARENES",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pdfPath": "ncertsolutionche24.pdf"
  },
  {
    "id": "ncertsolutionche25",
    "name": "25 - ALCOHOLS, PHENOLS AND ETHERS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pdfPath": "ncertsolutionche25.pdf"
  },
  {
    "id": "ncertsolutionche26",
    "name": "26 - ALDEHYDES, KETONES AND CARBOXYLIC ACIDS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pdfPath": "ncertsolutionche26.pdf"
  },
  {
    "id": "ncertsolutionche27",
    "name": "27 - AMINES",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pdfPath": "ncertsolutionche27.pdf"
  },
  {
    "id": "ncertsolutionche28",
    "name": "28 - BIOMOLECULES",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pdfPath": "ncertsolutionche28.pdf"
  },
  {
    "id": "ncertsolutionche29",
    "name": "29 - POLYMERS",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pdfPath": "ncertsolutionche29.pdf"
  },
  {
    "id": "ncertsolutionche30",
    "name": "30 - CHEMISTRY IN EVERYDAY LIFE",
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pdfPath": "ncertsolutionche30.pdf"
  },
{
    "id": "ncertsolutionbio1",
    "name": "1 - The Living World",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB01",
    "pdfPath": "ncertsolutionbio1.pdf"
  },
  {
    "id": "ncertsolutionbio2",
    "name": "2 - Biological Classification",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pdfPath": "ncertsolutionbio2.pdf"
  },
  {
    "id": "ncertsolutionbio3",
    "name": "3 - Plant Kingdom",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pdfPath": "ncertsolutionbio3.pdf"
  },
  {
    "id": "ncertsolutionbio4",
    "name": "4 - Animal Kingdom",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pdfPath": "ncertsolutionbio4.pdf"
  },
  {
    "id": "ncertsolutionbio5",
    "name": "5 - Morphology of Flowering Plants",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pdfPath": "ncertsolutionbio5.pdf"
  },
  {
    "id": "ncertsolutionbio6",
    "name": "6 - Anatomy of Flowering Plants",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pdfPath": "ncertsolutionbio6.pdf"
  },
  {
    "id": "ncertsolutionbio7",
    "name": "7 - Structural Organisation in Animals",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pdfPath": "ncertsolutionbio7.pdf"
  },
  {
    "id": "ncertsolutionbio8",
    "name": "8 - Cell The Unit of Life",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pdfPath": "ncertsolutionbio8.pdf"
  },
  {
    "id": "ncertsolutionbio9",
    "name": "9 - Biomolecules",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pdfPath": "ncertsolutionbio9.pdf"
  },
  {
    "id": "ncertsolutionbio10",
    "name": "10 - Cell Cycle and Cell Division",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pdfPath": "ncertsolutionbio10.pdf"
  },
  {
    "id": "ncertsolutionbio11",
    "name": "11 - Transport in Plants",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pdfPath": "ncertsolutionbio11.pdf"
  },
  {
    "id": "ncertsolutionbio12",
    "name": "12 - Mineral Nutrition",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB12",
    "pdfPath": "ncertsolutionbio12.pdf"
  },
  {
    "id": "ncertsolutionbio13",
    "name": "13 - Photosynthesis in Higher Plants",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB13",
    "pdfPath": "ncertsolutionbio13.pdf"
  },
  {
    "id": "ncertsolutionbio14",
    "name": "14 - Respiration in Plants",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pdfPath": "ncertsolutionbio14.pdf"
  },
  {
    "id": "ncertsolutionbio15",
    "name": "15 - Plant Growth and Development",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pdfPath": "ncertsolutionbio15.pdf"
  },
  {
    "id": "ncertsolutionbio16",
    "name": "16 - Digestion and Absorption",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pdfPath": "ncertsolutionbio16.pdf"
  },
  {
    "id": "ncertsolutionbio17",
    "name": "17 - Breathing and Exchange of Gases",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pdfPath": "ncertsolutionbio17.pdf"
  },
  {
    "id": "ncertsolutionbio18",
    "name": "18 - Body Fluids and Circulation",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pdfPath": "ncertsolutionbio18.pdf"
  },
  {
    "id": "ncertsolutionbio19",
    "name": "19 - Excretory Products and their Elimination",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pdfPath": "ncertsolutionbio19.pdf"
  },
  {
    "id": "ncertsolutionbio20",
    "name": "20 - Locomotion and Movement",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pdfPath": "ncertsolutionbio20.pdf"
  },
  {
    "id": "ncertsolutionbio21",
    "name": "21 - Neural Control and Coordination",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pdfPath": "ncertsolutionbio21.pdf"
  },
  {
    "id": "ncertsolutionbio22",
    "name": "22 - Chemical Coordination and integration",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pdfPath": "ncertsolutionbio22.pdf"
  },
  {
    "id": "ncertsolutionbio23",
    "name": "1 - Reproduction in Organism",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pdfPath": "ncertsolutionbio23.pdf"
  },
  {
    "id": "ncertsolutionbio24",
    "name": "2 - Sexual Reproduction in Flowering Plants",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pdfPath": "ncertsolutionbio24.pdf"
  },
  {
    "id": "ncertsolutionbio25",
    "name": "3 - Human Reproduction",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pdfPath": "ncertsolutionbio25.pdf"
  },
  {
    "id": "ncertsolutionbio26",
    "name": "4 - Reproductive Health",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB26",
    "pdfPath": "ncertsolutionbio26.pdf"
  },
  {
    "id": "ncertsolutionbio27",
    "name": "5 - Principles of Inheritance and Variation",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pdfPath": "ncertsolutionbio27.pdf"
  },
  {
    "id": "ncertsolutionbio28",
    "name": "6 - Molecular Basis of Inheritance",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pdfPath": "ncertsolutionbio28.pdf"
  },
  {
    "id": "ncertsolutionbio29",
    "name": "7-Evolution",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB29",
    "pdfPath": "ncertsolutionbio29.pdf"
  },
  {
    "id": "ncertsolutionbio30",
    "name": "8 - Human Health and Disease",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pdfPath": "ncertsolutionbio30.pdf"
  },
  {
    "id": "ncertsolutionbio31",
    "name": "9 - Strategies for Enhancement in Food Production",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pdfPath": "ncertsolutionbio31.pdf"
  },
  {
    "id": "ncertsolutionbio32",
    "name": "10 - Microbes in Human Welfare",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pdfPath": "ncertsolutionbio32.pdf"
  },
  {
    "id": "ncertsolutionbio33",
    "name": "11 - Biotechnology Principles and Processes",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pdfPath": "ncertsolutionbio33.pdf"
  },
  {
    "id": "ncertsolutionbio34",
    "name": "12 - Biotechnology and its Applications",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB34",
    "pdfPath": "ncertsolutionbio34.pdf"
  },
  {
    "id": "ncertsolutionbio35",
    "name": "13 - Organisms and Populations",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pdfPath": "ncertsolutionbio35.pdf"
  },
  {
    "id": "ncertsolutionbio36",
    "name": "14 - Ecosystem",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pdfPath": "ncertsolutionbio36.pdf"
  },
  {
    "id": "ncertsolutionbio37",
    "name": "16 - Environmental Issues",
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pdfPath": "ncertsolutionbio37.pdf"
  },

    
    {
      "id": "formulaphy1",
      "name": "1 - UNITS AND MEASUREMENTS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP01",
      "pdfPath": "formulaphy1.pdf"
    },
    {
      "id": "formulaphy2",
      "name": "2 - MOTION IN A STRAIGHT LINE",
      "type": "formula",
      "subject": "physics",
      "topic": "CP02",
      "pdfPath": "formulaphy2.pdf"
    },
    {
      "id": "formulaphy3",
      "name": "3 - MOTION IN A PLANE",
      "type": "formula",
      "subject": "physics",
      "topic": "CP03",
      "pdfPath": "formulaphy3.pdf"
    },
    {
      "id": "formulaphy4",
      "name": "4 - LAWS OF MOTION",
      "type": "formula",
      "subject": "physics",
      "topic": "CP04",
      "pdfPath": "formulaphy4.pdf"
    },
    {
      "id": "formulaphy5",
      "name": "5 - WORK, ENERGY AND POWER",
      "type": "formula",
      "subject": "physics",
      "topic": "CP05",
      "pdfPath": "formulaphy5.pdf"
    },
    {
      "id": "formulaphy6",
      "name": "6 - SYSTEM OF PARTICLES AND ROTATIONAL MOTION",
      "type": "formula",
      "subject": "physics",
      "topic": "CP06",
      "pdfPath": "formulaphy6.pdf"
    },
    {
      "id": "formulaphy7",
      "name": "7 - GRAVITATION",
      "type": "formula",
      "subject": "physics",
      "topic": "CP07",
      "pdfPath": "formulaphy7.pdf"
    },
    {
      "id": "formulaphy8",
      "name": "8 - MECHANICAL PROPERTIES OF SOLIDS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP08",
      "pdfPath": "formulaphy8.pdf"
    },
    {
      "id": "formulaphy9",
      "name": "9 - MECHANICAL PROPERTIES OF FLUIDS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP09",
      "pdfPath": "formulaphy9.pdf"
    },
    {
      "id": "formulaphy10",
      "name": "10 - THERMAL PROPERTIES OF MATTER",
      "type": "formula",
      "subject": "physics",
      "topic": "CP10",
      "pdfPath": "formulaphy10.pdf"
    },
    {
      "id": "formulaphy11",
      "name": "11 - THERMODYNAMICS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP11",
      "pdfPath": "formulaphy11.pdf"
    },
    {
      "id": "formulaphy12",
      "name": "12 - KINETIC THEORY",
      "type": "formula",
      "subject": "physics",
      "topic": "CP12",
      "pdfPath": "formulaphy12.pdf"
    },
    {
      "id": "formulaphy13",
      "name": "13 - OSCILLATIONS AND SHM",
      "type": "formula",
      "subject": "physics",
      "topic": "CP13",
      "pdfPath": "formulaphy13.pdf"
    },
    {
      "id": "formulaphy14",
      "name": "14 - WAVES",
      "type": "formula",
      "subject": "physics",
      "topic": "CP14",
      "pdfPath": "formulaphy14.pdf"
    },
    {
      "id": "formulaphy15",
      "name": "15 - ELECTRIC CHARGES AND FIELDS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP15",
      "pdfPath": "formulaphy15.pdf"
    },
    {
      "id": "formulaphy16",
      "name": "16 - ELECTRIC POTENTIAL AND CAPACITANCE",
      "type": "formula",
      "subject": "physics",
      "topic": "CP16",
      "pdfPath": "formulaphy16.pdf"
    },
    {
      "id": "formulaphy17",
      "name": "17 - CURRENT ELECTRICITY",
      "type": "formula",
      "subject": "physics",
      "topic": "CP17",
      "pdfPath": "formulaphy17.pdf"
    },
    {
      "id": "formulaphy18",
      "name": "18 - MOVING CHARGES AND MAGNETISM",
      "type": "formula",
      "subject": "physics",
      "topic": "CP18",
      "pdfPath": "formulaphy18.pdf"
    },
    {
      "id": "formulaphy19",
      "name": "19 - MAGNETISM AND MATTER",
      "type": "formula",
      "subject": "physics",
      "topic": "CP19",
      "pdfPath": "formulaphy19.pdf"
    },
    {
      "id": "formulaphy20",
      "name": "20 - ELECTROMAGNETIC INDUCTION",
      "type": "formula",
      "subject": "physics",
      "topic": "CP20",
      "pdfPath": "formulaphy20.pdf"
    },
    {
      "id": "formulaphy21",
      "name": "21 - ALTERNATING CURRENT",
      "type": "formula",
      "subject": "physics",
      "topic": "CP21",
      "pdfPath": "formulaphy21.pdf"
    },
    {
      "id": "formulaphy22",
      "name": "22 - ELECTROMAGNETIC WAVES",
      "type": "formula",
      "subject": "physics",
      "topic": "CP22",
      "pdfPath": "formulaphy22.pdf"
    },
    {
      "id": "formulaphy23",
      "name": "23 - RAY OPTICS AND OPTICAL INSTRUMENTS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP23",
      "pdfPath": "formulaphy23.pdf"
    },
    {
      "id": "formulaphy24",
      "name": "24 - WAVE OPTICS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP24",
      "pdfPath": "formulaphy24.pdf"
    },
    {
      "id": "formulaphy25",
      "name": "25 - DUAL NATURE OF RADIATION AND MATTER",
      "type": "formula",
      "subject": "physics",
      "topic": "CP25",
      "pdfPath": "formulaphy25.pdf"
    },
    {
      "id": "formulaphy26",
      "name": "26 - NUCLEI",
      "type": "formula",
      "subject": "physics",
      "topic": "CP26",
      "pdfPath": "formulaphy26.pdf"
    },
    {
      "id": "formulaphy27",
      "name": "27 - SEMICONDUCTOR ELECTRONICS",
      "type": "formula",
      "subject": "physics",
      "topic": "CP27",
      "pdfPath": "formulaphy27.pdf"
    },
    {
      "id": "formulache1",
      "name": "1 - SOME BASIC CONCEPTS OF CHEMISTRY",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC01",
      "pdfPath": "formulache1.pdf"
    },
    {
      "id": "formulache2",
      "name": "2 - STRUCTURE OF ATOM",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC02",
      "pdfPath": "formulache2.pdf"
    },
    {
      "id": "formulache3",
      "name": "3 - CLASSIFICATION OF ELEMENTS AND PERIODICITY IN PROPERTIES",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC03",
      "pdfPath": "formulache3.pdf"
    },
    {
      "id": "formulache4",
      "name": "4 - CHEMICAL BONDING AND MOLECULAR STRUCTURE",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC04",
      "pdfPath": "formulache4.pdf"
    },
    {
      "id": "formulache5",
      "name": "5 - THERMODYNAMICS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC05",
      "pdfPath": "formulache5.pdf"
    },
    {
      "id": "formulache6",
      "name": "6 - EQUILIBRIUM",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC06",
      "pdfPath": "formulache6.pdf"
    },
    {
      "id": "formulache7",
      "name": "7 - REDOX REACTIONS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC07",
      "pdfPath": "formulache7.pdf"
    },
    {
      "id": "formulache8",
      "name": "8 - S-BLOCK ELEMENTS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC08",
      "pdfPath": "formulache8.pdf"
    },
    {
      "id": "formulache9",
      "name": "9 - SOME P-BLOCK ELEMENTS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC09",
      "pdfPath": "formulache9.pdf"
    },
    {
      "id": "formulache10",
      "name": "10 - P-BLOCK ELEMENTS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC10",
      "pdfPath": "formulache10.pdf"
    },
    {
      "id": "formulache11",
      "name": "11 - ORGANIC CHEMISTRY: SOME BASIC PRINCIPLES AND TECHNIQUES",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC11",
      "pdfPath": "formulache11.pdf"
    },
    {
      "id": "formulache12",
      "name": "12 - HYDROCARBONS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC12",
      "pdfPath": "formulache12.pdf"
    },
    {
      "id": "formulache13",
      "name": "13 - SOLUTIONS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC13",
      "pdfPath": "formulache13.pdf"
    },
    {
      "id": "formulache14",
      "name": "14 - ELECTROCHEMISTRY",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC14",
      "pdfPath": "formulache14.pdf"
    },
    {
      "id": "formulache15",
      "name": "15 - CHEMICAL KINETICS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC15",
      "pdfPath": "formulache15.pdf"
    },
    {
      "id": "formulache16",
      "name": "16 - SURFACE CHEMISTRY",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC16",
      "pdfPath": "formulache16.pdf"
    },
    {
      "id": "formulache17",
      "name": "17 - GENERAL PRINCIPLES AND PROCESSES OF ISOLATION OF ELEMENTS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC17",
      "pdfPath": "formulache17.pdf"
    },
    {
      "id": "formulache18",
      "name": "18 - D AND F BLOCK ELEMENTS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC18",
      "pdfPath": "formulache18.pdf"
    },
    {
      "id": "formulache19",
      "name": "19 - COORDINATION COMPOUNDS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC19",
      "pdfPath": "formulache19.pdf"
    },
    {
      "id": "formulache20",
      "name": "20 - HALOALKANES AND HALOARENES",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC20",
      "pdfPath": "formulache20.pdf"
    },
    {
      "id": "formulache21",
      "name": "21 - ALCOHOLS, PHENOLS AND ETHERS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC21",
      "pdfPath": "formulache21.pdf"
    },
    {
      "id": "formulache22",
      "name": "22 - ALDEHYDES, KETONES AND CARBOXYLIC ACIDS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC22",
      "pdfPath": "formulache22.pdf"
    },
    {
      "id": "formulache23",
      "name": "23 - ORGANIC COMPOUNDS CONTAINING NITROGEN",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC23",
      "pdfPath": "formulache23.pdf"
    },
    {
      "id": "formulache24",
      "name": "24 - BIOMOLECULES",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC24",
      "pdfPath": "formulache24.pdf"
    },
    {
      "id": "formulache25",
      "name": "25 - POLYMERS",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC25",
      "pdfPath": "formulache25.pdf"
    },
    {
      "id": "formulache26",
      "name": "26 - CHEMISTRY IN EVERYDAY LIFE",
      "type": "formula",
      "subject": "chemistry",
      "topic": "CC26",
      "pdfPath": "formulache26.pdf"
    },
    {
      "id": "formulabio1",
      "name": "1 - THE LIVING WORLD",
      "type": "formula",
      "subject": "biology",
      "topic": "CB01",
      "pdfPath": "formulabio1.pdf"
    },
    {
      "id": "formulabio2",
      "name": "2 - BIOLOGICAL CLASSIFICATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB02",
      "pdfPath": "formulabio2.pdf"
    },
    {
      "id": "formulabio3",
      "name": "3 - PLANT KINGDOM",
      "type": "formula",
      "subject": "biology",
      "topic": "CB03",
      "pdfPath": "formulabio3.pdf"
    },
    {
      "id": "formulabio4",
      "name": "4 - ANIMAL KINGDOM",
      "type": "formula",
      "subject": "biology",
      "topic": "CB04",
      "pdfPath": "formulabio4.pdf"
    },
    {
      "id": "formulabio5",
      "name": "5 - MORPHOLOGY OF FLOWERING PLANTS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB05",
      "pdfPath": "formulabio5.pdf"
    },
    {
      "id": "formulabio6",
      "name": "6 - ANATOMY OF FLOWERING PLANTS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB06",
      "pdfPath": "formulabio6.pdf"
    },
    {
      "id": "formulabio7",
      "name": "7 - STRUCTURAL ORGANISATION IN ANIMALS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB07",
      "pdfPath": "formulabio7.pdf"
    },
    {
      "id": "formulabio8",
      "name": "8 - CELL: THE UNIT OF LIFE",
      "type": "formula",
      "subject": "biology",
      "topic": "CB08",
      "pdfPath": "formulabio8.pdf"
    },
    {
      "id": "formulabio9",
      "name": "9 - CELL CYCLE AND CELL DIVISION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB09",
      "pdfPath": "formulabio9.pdf"
    },
    {
      "id": "formulabio10",
      "name": "10 - PHOTOSYNTHESIS IN HIGHER PLANTS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB10",
      "pdfPath": "formulabio10.pdf"
    },
    {
      "id": "formulabio11",
      "name": "11 - RESPIRATION IN PLANTS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB11",
      "pdfPath": "formulabio11.pdf"
    },
    {
      "id": "formulabio12",
      "name": "12 - PLANT GROWTH AND DEVELOPMENT",
      "type": "formula",
      "subject": "biology",
      "topic": "CB12",
      "pdfPath": "formulabio12.pdf"
    },
    {
      "id": "formulabio13",
      "name": "13 - SEXUAL REPRODUCTION IN FLOWERING PLANTS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB13",
      "pdfPath": "formulabio13.pdf"
    },
    {
      "id": "formulabio14",
      "name": "14 - HUMAN REPRODUCTION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB14",
      "pdfPath": "formulabio14.pdf"
    },
    {
      "id": "formulabio15",
      "name": "15 - REPRODUCTIVE HEALTH",
      "type": "formula",
      "subject": "biology",
      "topic": "CB15",
      "pdfPath": "formulabio15.pdf"
    },
    {
      "id": "formulabio16",
      "name": "16 - PRINCIPLES OF INHERITANCE AND VARIATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB16",
      "pdfPath": "formulabio16.pdf"
    },
    {
      "id": "formulabio17",
      "name": "17 - MOLECULAR BASIS OF INHERITANCE",
      "type": "formula",
      "subject": "biology",
      "topic": "CB17",
      "pdfPath": "formulabio17.pdf"
    },
    {
      "id": "formulabio18",
      "name": "18 - HUMAN HEALTH AND DISEASES",
      "type": "formula",
      "subject": "biology",
      "topic": "CB18",
      "pdfPath": "formulabio18.pdf"
    },
    {
      "id": "formulabio19",
      "name": "19 - STRATEGIES FOR ENHANCEMENT IN FOOD PRODUCTION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB19",
      "pdfPath": "formulabio19.pdf"
    },
    {
      "id": "formulabio20",
      "name": "20 - MICROBES IN HUMAN WELFARE",
      "type": "formula",
      "subject": "biology",
      "topic": "CB20",
      "pdfPath": "formulabio20.pdf"
    },
    {
      "id": "formulabio21",
      "name": "21 - BIOTECHNOLOGY: PRINCIPLES AND PROCESSES",
      "type": "formula",
      "subject": "biology",
      "topic": "CB21",
      "pdfPath": "formulabio21.pdf"
    },
    {
      "id": "formulabio22",
      "name": "22 - BIOTECHNOLOGY AND ITS APPLICATIONS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB22",
      "pdfPath": "formulabio22.pdf"
    },
    {
      "id": "formulabio23",
      "name": "23 - ORGANISMS AND POPULATIONS",
      "type": "formula",
      "subject": "biology",
      "topic": "CB23",
      "pdfPath": "formulabio23.pdf"
    },
    {
      "id": "formulabio24",
      "name": "24 - ECOSYSTEM",
      "type": "formula",
      "subject": "biology",
      "topic": "CB24",
      "pdfPath": "formulabio24.pdf"
    },
    {
      "id": "formulabio25",
      "name": "25 - BIODIVERSITY AND ITS CONSERVATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB25",
      "pdfPath": "formulabio25.pdf"
    },
    {
      "id": "formulabio26",
      "name": "26 - ENVIRONMENTAL ISSUES",
      "type": "formula",
      "subject": "biology",
      "topic": "CB26",
      "pdfPath": "formulabio26.pdf"
    },
    {
      "id": "formulabio27",
      "name": "27 - BODY FLUIDS AND CIRCULATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB27",
      "pdfPath": "formulabio27.pdf"
    },
    {
      "id": "formulabio28",
      "name": "28 - EXCRETORY PRODUCTS AND THEIR ELIMINATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB28",
      "pdfPath": "formulabio28.pdf"
    },
    {
      "id": "formulabio29",
      "name": "29 - LOCOMOTION AND MOVEMENT",
      "type": "formula",
      "subject": "biology",
      "topic": "CB29",
      "pdfPath": "formulabio29.pdf"
    },
    {
      "id": "formulabio30",
      "name": "30 - NEURAL CONTROL AND COORDINATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB30",
      "pdfPath": "formulabio30.pdf"
    },
    {
      "id": "formulabio31",
      "name": "31 - CHEMICAL COORDINATION AND INTEGRATION",
      "type": "formula",
      "subject": "biology",
      "topic": "CB31",
      "pdfPath": "formulabio31.pdf"
    },
    {
      "id": "formulabio32",
      "name": "32 - BREATHING AND EXCHANGE OF GASES",
      "type": "formula",
      "subject": "biology",
      "topic": "CB32",
      "pdfPath": "formulabio32.pdf"
    },
    

    {
   "id": "flashcardphy1",
  "name": "1-Unit and Dimensions",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP01",
  "pdfPath": "flashcardphy1.pdf"
},
{
     "id": "flashcardphy2",
  "name": "2-Motion in a Straight Line",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP02",
  "pdfPath": "flashcardphy2.pdf"
},
{
    "id": "flashcardphy3",
  "name": "3-Projectile Motion",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP03",
  "pdfPath": "flashcardphy3.pdf"
},
{
    "id": "flashcardphy4",
  "name": "4-Vectors",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP04",
  "pdfPath": "flashcardphy4.pdf"
},
{
  "id": "flashcardphy5",
  "name": "5-Laws of Motion",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP05",
  "pdfPath": "flashcardphy5.pdf"
},
{
  "id": "flashcardphy6",
  "name": "6-Work, Energy and Power",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP06",
  "pdfPath": "flashcardphy6.pdf"
},
{
  "id": "flashcardphy7",
  "name": "7-Rotational Motion",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP07",
  "pdfPath": "flashcardphy7.pdf"
},
{
  "id": "flashcardphy8",
  "name": "8-Gravitation",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP08",
  "pdfPath": "flashcardphy8.pdf"
},
{
  "id": "flashcardphy9",
  "name": "9-Elasticity",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP09",
  "pdfPath": "flashcardphy9.pdf"
},
{
  "id": "flashcardphy10",
  "name": "10-Fluids",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP10",
  "pdfPath": "flashcardphy10.pdf"
},
{
  "id": "flashcardphy11",
  "name": "11-Thermal Matter",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pdfPath": "flashcardphy11.pdf"
},
{
  "id": "flashcardphy12",
  "name": "12-Kinetic Theormal Matter",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP12",
  "pdfPath": "flashcardphy12.pdf"
},
{
  "id": "flashcardphy13",
  "name": "13-Oscillations",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP13",
  "pdfPath": "flashcardphy13.pdf"
},
{
  "id": "flashcardphy14",
  "name": "14-Waves",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP14",
  "pdfPath": "flashcardphy14.pdf"
},
{
  "id": "flashcardphy15",
  "name": "15-Electrostatics",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pdfPath": "flashcardphy15.pdf"
},
{
  "id": "flashcardphy16",
  "name": "16-Current Electricity",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP16",
  "pdfPath": "flashcardphy16.pdf"
},
{
  "id": "flashcardphy17",
  "name": "17-Magnetic Effects of Current",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pdfPath": "flashcardphy17.pdf"
},
{
  "id": "flashcardphy18",
  "name": "18-Alternatiing Currents",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pdfPath": "flashcardphy18.pdf"
},
{
  "id": "flashcardphy19",
  "name": "19-Optics",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pdfPath": "flashcardphy19.pdf"
},
{
  "id": "flashcardphy20",
  "name": "20-Electromagnetic Spectrum",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP20",
  "pdfPath": "flashcardphy20.pdf"
},
{
  "id": "flashcardphy21",
  "name": "21-Atoms and Nuclei",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP21",
  "pdfPath": "flashcardphy21.pdf"
},
{
  "id": "flashcardphy22",
  "name": "22-Photoelectric Effect",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP22",
  "pdfPath": "flashcardphy22.pdf"
},
{
  "id": "flashcardphy23",
  "name": "23-Semiconductors",
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pdfPath": "flashcardphy23.pdf"
},
{
  "id": "flashcardche1",
  "name": "1-Some Basic Concepts of Chemistry",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC01",
  "pdfPath": "flashcardche1.pdf"
},
{
  "id": "flashcardche2",
  "name": "2-Structure of Atom",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pdfPath": "flashcardche2.pdf"
},
{
  "id": "flashcardche3",
  "name": "3-Thermodynamics & Thermochemistry",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pdfPath": "flashcardche3.pdf"
},
{
  "id": "flashcardche4",
  "name": "4-Chemical Equilibrium",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC04",
  "pdfPath": "flashcardche4.pdf"
},
{
  "id": "flashcardche5",
  "name": "5-Ionic Equilibrium",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC05",
  "pdfPath": "flashcardche5.pdf"
},
{
  "id": "flashcardche6",
  "name": "6-Dilute Solutions",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pdfPath": "flashcardche6.pdf"
},
{
  "id": "flashcardche7",
  "name": "7-Electrochemistry",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pdfPath": "flashcardche7.pdf"
},
{
  "id": "flashcardche8",
  "name": "8-Chemical Kinetics",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pdfPath": "flashcardche8.pdf"
},
{
  "id": "flashcardche9",
  "name": "9-Periodic Properties",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pdfPath": "flashcardche9.pdf"
},
{
  "id": "flashcardche10",
  "name": "10-Chemical Bonding and Structures",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pdfPath": "flashcardche10.pdf"
},
{
  "id": "flashcardche11",
  "name": "11-Coordination Compounds",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pdfPath": "flashcardche11.pdf"
},
{
  "id": "flashcardche12",
  "name": "12-D & F Block Elements",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pdfPath": "flashcardche12.pdf"
},
{
  "id": "flashcardche13",
  "name": "13-Biomolecules",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pdfPath": "flashcardche13.pdf"
},
{
  "id": "flashcardche14",
  "name": "14-Chemistry in Everyday Life",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC14",
  "pdfPath": "flashcardche14.pdf"
},
{
  "id": "flashcardche15",
  "name": "15-Environmental Chemistry",
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pdfPath": "flashcardche15.pdf"
},
{
  "id": "flashcardbio1",
  "name": "1-Cell - The Unit of Life",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pdfPath": "flashcardbio1.pdf"
},
{
  "id": "flashcardbio2",
  "name": "2-Cell Cycle and Division",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB02",
  "pdfPath": "flashcardbio2.pdf"
},
{
  "id": "flashcardbio3",
  "name": "3-Animal Kingdom",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pdfPath": "flashcardbio3.pdf"
},
{
  "id": "flashcardbio4",
  "name": "4-Structural Organisation in Animals",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB04",
  "pdfPath": "flashcardbio4.pdf"
},
{
  "id": "flashcardbio5",
  "name": "5-Biomolecules",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pdfPath": "flashcardbio5.pdf"
},
{
  "id": "flashcardbio6",
  "name": "6-Breathing and Exchange of Gases",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pdfPath": "flashcardbio6.pdf"
},
{
  "id": "flashcardbio7",
  "name": "7-Body Fluids and Circulaton",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pdfPath": "flashcardbio7.pdf"
},
{
  "id": "flashcardbio8",
  "name": "8-Excretory Products & their Elimination",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pdfPath": "flashcardbio8.pdf"
},
{
  "id": "flashcardbio9",
  "name": "9-Location & movment",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pdfPath": "flashcardbio9.pdf"
},
{
  "id": "flashcardbio10",
  "name": "10-Neural control and Coordination",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pdfPath": "flashcardbio10.pdf"
},
{
  "id": "flashcardbio11",
  "name": "11-Chemical Coordination & Integration",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pdfPath": "flashcardbio11.pdf"
},
{
  "id": "flashcardbio12",
  "name": "12-Living World",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB12",
  "pdfPath": "flashcardbio12.pdf"
},
{
  "id": "flashcardbio13",
  "name": "13-Biological Classification",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pdfPath": "flashcardbio13.pdf"
},
{
  "id": "flashcardbio14",
  "name": "14-Plant Kingdom",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pdfPath": "flashcardbio14.pdf"
},
{
  "id": "flashcardbio15",
  "name": "15-Anatomy of Flowering Plants",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pdfPath": "flashcardbio15.pdf"
},
{
  "id": "flashcardbio16",
  "name": "16-Morphology of Flowering Plants",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pdfPath": "flashcardbio16.pdf"
},
{
  "id": "flashcardbio17",
  "name": "17-Plant Growth and Development",
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB17",
  "pdfPath": "flashcardbio17.pdf"
},
  {
 "id": "mindmapphy1",
  "name": "1-Basic Mathermatics",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP01",
  "pdfPath": "mindmapphy1.pdf"
},
{
"id": "mindmapphy2",
  "name": "2-Units and Measurments",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP02",
  "pdfPath": "mindmapphy2.pdf"
},
{
"id": "mindmapphy3",
  "name": "3-Motion in a Straight Line",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP03",
  "pdfPath": "mindmapphy3.pdf"
},
{
  "id": "mindmapphy4",
  "name": "4-Motion in a Plane",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP04",
  "pdfPath": "mindmapphy4.pdf"
},
{
  "id": "mindmapphy5",
  "name": "5-Newton's Laws of Motion",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP05",
  "pdfPath": "mindmapphy5.pdf"
},
{
  "id": "mindmapphy6",
  "name": "6-Work, Energy and Power",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP06",
  "pdfPath": "mindmapphy6.pdf"
},
{
  "id": "mindmapphy7",
  "name": "7-System of Particles and Rotational motion",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP07",
  "pdfPath": "mindmapphy7.pdf"
},
{
  "id": "mindmapphy8",
  "name": "8-Gravitation",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP08",
  "pdfPath": "mindmapphy8.pdf"
},
{
  "id": "mindmapphy9",
  "name": "9-Mechanical Properties of Solids",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP09",
  "pdfPath": "mindmapphy9.pdf"
},
{
  "id": "mindmapphy10",
  "name": "10-Mechanical properties of Fluids",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP10",
  "pdfPath": "mindmapphy10.pdf"
},
{
  "id": "mindmapphy11",
  "name": "11-Thermal Properties of Matter",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP11",
  "pdfPath": "mindmapphy11.pdf"
},
{
  "id": "mindmapphy12",
  "name": "12-Kinetic Therory of Gases",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP12",
  "pdfPath": "mindmapphy12.pdf"
},
{
  "id": "mindmapphy13",
  "name": "13-Superposition of Waves",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP13",
  "pdfPath": "mindmapphy13.pdf"
},
{
  "id": "mindmapphy14",
  "name": "14-Electrostatics",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP14",
  "pdfPath": "mindmapphy14.pdf"
},
{
  "id": "mindmapphy15",
  "name": "15-Electric Current",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP15",
  "pdfPath": "mindmapphy15.pdf"
},
{
  "id": "mindmapphy16",
  "name": "16-Moving charges and Magnetism",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP16",
  "pdfPath": "mindmapphy16.pdf"
},
{
  "id": "mindmapphy17",
  "name": "17-Electromagnetic Induction",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP17",
  "pdfPath": "mindmapphy17.pdf"
},
{
  "id": "mindmapphy18",
  "name": "18-Altrnating Current",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP18",
  "pdfPath": "mindmapphy18.pdf"
},
{
  "id": "mindmapphy19",
  "name": "19-EM Waves",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP19",
  "pdfPath": "mindmapphy19.pdf"
},
{
  "id": "mindmapphy20",
  "name": "20-Ray Optics",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP20",
  "pdfPath": "mindmapphy20.pdf"
},
{
  "id": "mindmapphy21",
  "name": "21-Wave Optics",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP21",
  "pdfPath": "mindmapphy21.pdf"
},
{
  "id": "mindmapphy22",
  "name": "22-Dual Nature of Radiation and Matter",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP22",
  "pdfPath": "mindmapphy22.pdf"
},
{
  "id": "mindmapphy23",
  "name": "23-Nuclear",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP23",
  "pdfPath": "mindmapphy23.pdf"
},
{
  "id": "mindmapphy24",
  "name": "24-Semiconductor Electronics",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP24",
  "pdfPath": "mindmapphy24.pdf"
},
{
  "id": "mindmapphy25",
  "name": "25-Capacitor",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP25",
  "pdfPath": "mindmapphy25.pdf"
},
{
  "id": "mindmapphy26",
  "name": "26-Magnetism and Matter",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP26",
  "pdfPath": "mindmapphy26.pdf"
},
{
  "id": "mindmapphy27",
  "name": "27-Simple Harmonic Motion",
  "type": "mindmap",
  "subject": "physics",
  "topic": "CP27",
  "pdfPath": "mindmapphy27.pdf"
},
{
  "id": "mindmapche1",
  "name": "1-Law of Chemical Combinations",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC01",
  "pdfPath": "mindmapche1.pdf"
},
{
 "id": "mindmapche2",
  "name": "2-structure of Atom",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC02",
  "pdfPath": "mindmapche2.pdf"
},
{
 "id": "mindmapche3",
  "name": "3-Genesis of Classification",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC03",
  "pdfPath": "mindmapche3.pdf"
},
{
  "id": "mindmapche4",
  "name": "4-Chemical Bonding and Molecular Structure",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC04",
  "pdfPath": "mindmapche4.pdf"
},
{
  "id": "mindmapche5",
  "name": "5-States of Matter",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC05",
  "pdfPath": "mindmapche5.pdf"
},
{
  "id": "mindmapche6",
  "name": "6-Thermodynamics",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC06",
  "pdfPath": "mindmapche6.pdf"
},
{
  "id": "mindmapche7",
  "name": "7-Equilibrium",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC07",
  "pdfPath": "mindmapche7.pdf"
},
{
  "id": "mindmapche8",
  "name": "8-Redox Reaction",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC08",
  "pdfPath": "mindmapche8.pdf"
},
{
  "id": "mindmapche9",
  "name": "9-Hydrogen",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC09",
  "pdfPath": "mindmapche9.pdf"
},
{
  "id": "mindmapche10",
  "name": "10-The S-Block Elements",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC10",
  "pdfPath": "mindmapche10.pdf"
},
{
  "id": "mindmapche11",
  "name": "11-Ther p-Block Elements",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC11",
  "pdfPath": "mindmapche11.pdf"
},
{
  "id": "mindmapche12",
  "name": "12-Some Basic Principles and Techniques",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC12",
  "pdfPath": "mindmapche12.pdf"
},
{
  "id": "mindmapche13",
  "name": "13-Hydrocarbons",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC13",
  "pdfPath": "mindmapche13.pdf"
},
{
  "id": "mindmapche14",
  "name": "14-Haloalkane and Haloarene",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC14",
  "pdfPath": "mindmapche14.pdf"
},
{
  "id": "mindmapche15",
  "name": "15-Aldehyde, Ketones and Carboxylic Acid",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC15",
  "pdfPath": "mindmapche15.pdf"
},
{
  "id": "mindmapche16",
  "name": "16-Amines",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC16",
  "pdfPath": "mindmapche16.pdf"
},
{
  "id": "mindmapche17",
  "name": "17-Biomolecules",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC17",
  "pdfPath": "mindmapche17.pdf"
},
{
  "id": "mindmapche18",
  "name": "18-Plymers",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC18",
  "pdfPath": "mindmapche18.pdf"
},
{
  "id": "mindmapche19",
  "name": "19-Chemistry in Everyday Life",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC19",
  "pdfPath": "mindmapche19.pdf"
},
{
  "id": "mindmapche20",
  "name": "20-Environmental Chemistry",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC20",
  "pdfPath": "mindmapche20.pdf"
},
{
  "id": "mindmapche21",
  "name": "21-Efects in Crystals",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC21",
  "pdfPath": "mindmapche21.pdf"
},
{
  "id": "mindmapche22",
  "name": "22-Solutions",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC22",
  "pdfPath": "mindmapche22.pdf"
},
{
  "id": "mindmapche23",
  "name": "23-Electrochemistry",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC23",
  "pdfPath": "mindmapche23.pdf"
},
{
  "id": "mindmapche24",
  "name": "24-Chemical Kinetics",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC24",
  "pdfPath": "mindmapche24.pdf"
},
{
  "id": "mindmapche25",
  "name": "25-Surface Chemistry",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC25",
  "pdfPath": "mindmapche25.pdf"
},
{
  "id": "mindmapche26",
  "name": "26-Coordination Compounds",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC26",
  "pdfPath": "mindmapche26.pdf"
},
{
  "id": "mindmapche27",
  "name": "27-D and F Block Elements",
  "type": "mindmap",
  "subject": "chemistry",
  "topic": "CC27",
  "pdfPath": "mindmapche27.pdf"
},
{
  "id": "mindmapbio1",
  "name": "1-Respiration in Plants",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB01",
  "pdfPath": "mindmapbio1.pdf"
},
{
 "id": "mindmapbio2",
  "name": "2-Cell",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB02",
  "pdfPath": "mindmapbio2.pdf"
},
{
 "id": "mindmapbio3",
 "name": "3-Structural Organisation in Animals",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB03",
  "pdfPath": "mindmapbio3.pdf"
},
{
  "id": "mindmapbio4",
  "name": "4-Excretory Products  and Their Elimination",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB04",
  "pdfPath": "mindmapbio4.pdf"
},
{
  "id": "mindmapbio5",
  "name": "5-Microbes in Human Welfare",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB05",
  "pdfPath": "mindmapbio5.pdf"
},
{
  "id": "mindmapbio6",
  "name": "6-Molecular Basis of Inheritance",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB06",
  "pdfPath": "mindmapbio6.pdf"
},
{
  "id": "mindmapbio7",
  "name": "7-Sexual Perroduction in Flowering Plants",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB07",
  "pdfPath": "mindmapbio7.pdf"
},
{
  "id": "mindmapbio8",
  "name": "8-The Living World",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB08",
  "pdfPath": "mindmapbio8.pdf"
},
{
  "id": "mindmapbio9",
  "name": "9-Biological Classification",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB09",
  "pdfPath": "mindmapbio9.pdf"
},
{
  "id": "mindmapbio10",
  "name": "10-Plant Kingdom",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB10",
  "pdfPath": "mindmapbio10.pdf"
},
{
  "id": "mindmapbio11",
  "name": "11-Morphology of Flowering Plants",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB11",
  "pdfPath": "mindmapbio11.pdf"
},
{
  "id": "mindmapbio12",
  "name": "12-Anatomy of Flowering Plants",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB12",
  "pdfPath": "mindmapbio12.pdf"
},
{
  "id": "mindmapbio13",
  "name": "13-Cell - the Unit jof Life",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB13",
  "pdfPath": "mindmapbio13.pdf"
},
{
  "id": "mindmapbio14",
  "name": "14-Cell Cucle and Cell Division",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB14",
  "pdfPath": "mindmapbio14.pdf"
},
{
  "id": "mindmapbio15",
  "name": "15-Transportin Plants",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB15",
  "pdfPath": "mindmapbio15.pdf"
},
{
  "id": "mindmapbio16",
  "name": "16-Mineral Nutrition",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB16",
  "pdfPath": "mindmapbio16.pdf"
},
{
  "id": "mindmapbio17",
  "name": "17-Photosynthesis in Higher Plants",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB17",
  "pdfPath": "mindmapbio17.pdf"
},
{
  "id": "mindmapbio18",
  "name": "18-Plant Growth and Evelopment",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB18",
  "pdfPath": "mindmapbio18.pdf"
},
{
  "id": "mindmapbio19",
  "name": "19-Reproduction in Organisms",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB19",
  "pdfPath": "mindmapbio19.pdf"
},
{
  "id": "mindmapbio20",
  "name": "20-Principles of Inheritance and Variation",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB20",
  "pdfPath": "mindmapbio20.pdf"
},
{
  "id": "mindmapbio21",
  "name": "21-Strategies for Enhancementin Food Production",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB21",
  "pdfPath": "mindmapbio21.pdf"
},
{
  "id": "mindmapbio22",
  "name": "22-Organisms and Populations",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB22",
  "pdfPath": "mindmapbio22.pdf"
},
{
  "id": "mindmapbio23",
  "name": "23-Econsystem",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB23",
  "pdfPath": "mindmapbio23.pdf"
},
{
  "id": "mindmapbio24",
  "name": "24-Biodiversity and Conservation",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB24",
  "pdfPath": "mindmapbio24.pdf"
},
{
  "id": "mindmapbio25",
  "name": "25-Environmental Issues",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB25",
  "pdfPath": "mindmapbio25.pdf"
},
{
  "id": "mindmapbio26",
  "name": "26-Animal Kingdom Non-Chordates",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB26",
  "pdfPath": "mindmapbio26.pdf"
},
{
  "id": "mindmapbio27",
  "name": "27-Animal Kingdomchordates",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB27",
  "pdfPath": "mindmapbio27.pdf"
},
{
  "id": "mindmapbio28",
  "name": "28-Structural Organisation in Animals Animal Tissues",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB28",
  "pdfPath": "mindmapbio28.pdf"
},
{
  "id": "mindmapbio29",
  "name": "29-Structural Organisation in Animals Animal Morphology",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB29",
  "pdfPath": "mindmapbio29.pdf"
},
{
  "id": "mindmapbio30",
  "name": "30 Biomolecules",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB30",
  "pdfPath": "mindmapbio30.pdf"
},
{
  "id": "mindmapbio31",
  "name": "31-digestion and Absorption",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB31",
  "pdfPath": "mindmapbio31.pdf"
},
{
  "id": "mindmapbio32",
  "name": "32-Breathing and Exchanges of Gases",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB32",
  "pdfPath": "mindmapbio32.pdf"
},
{
  "id": "mindmapbio33",
  "name": "33-Body Fluids and circulation",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB33",
  "pdfPath": "mindmapbio33.pdf"
},
{
  "id": "mindmapbio34",
  "name": "34-Locomotion and Movement",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB34",
  "pdfPath": "mindmapbio34.pdf"
},
{
  "id": "mindmapbio35",
  "name": "35-Neural Control and Coordination",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB35",
  "pdfPath": "mindmapbio35.pdf"
},
{
  "id": "mindmapbio36",
  "name": "36-Chmical Coordination and Integration",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB36",
  "pdfPath": "mindmapbio36.pdf"
},
{
  "id": "mindmapbio37",
  "name": "37-Reproduction in Organisms",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB37",
  "pdfPath": "mindmapbio37.pdf"
},
{
  "id": "mindmapbio38",
  "name": "38-Human Reproduction",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB38",
  "pdfPath": "mindmapbio38.pdf"
},
{
  "id": "mindmapbio39",
  "name": "39-Reproductive Health",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB39",
  "pdfPath": "mindmapbio39.pdf"
},
{
  "id": "mindmapbio40",
  "name": "40-Evolution",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB40",
  "pdfPath": "mindmapbio40.pdf"
},
{
  "id": "mindmapbio41",
  "name": "41-Human Health and disease",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB41",
  "pdfPath": "mindmapbio41.pdf"
},
{
  "id": "mindmapbio42",
  "name": "42-Strategies for Enhancement in Food Production",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB42",
  "pdfPath": "mindmapbio42.pdf"
},
{
  "id": "mindmapbio43",
  "name": "43-Biotechnology",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB43",
  "pdfPath": "mindmapbio43.pdf"
},
{
  "id": "mindmapbio44",
  "name": "44-Biotechnology an dIts Applications",
  "type": "mindmap",
  "subject": "biology",
  "topic": "CB44",
  "pdfPath": "mindmapbio44.pdf"
},





  {
    "id": "topernotephy1",
    "name": "1- Basic Maths",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pdfPath": "topernotephy1.pdf"
  },
  {
    "id": "topernotephy2",
    "name": "2-Vector",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pdfPath": "topernotephy2.pdf"
  },
  {
    "id": "topernotephy3",
    "name": "3-Unit & Dimensions",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pdfPath": "topernotephy3.pdf"
  },
  {
    "id": "topernotephy4",
    "name": "4-Motion in Striaight Line",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pdfPath": "topernotephy4.pdf"
  },
  {
    "id": "topernotephy5",
    "name": "5-Motion in Plane",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pdfPath": "topernotephy5.pdf"
  },
  {
    "id": "topernotephy6",
    "name": "6-Law of Motion",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pdfPath": "topernotephy6.pdf"
  },
  {
    "id": "topernotephy7",
    "name": "7-Friction",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pdfPath": "topernotephy7.pdf"
  },
  {
    "id": "topernotephy8",
    "name": "8-Work Power and Energy",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pdfPath": "topernotephy8.pdf"
  },
  {
    "id": "topernotephy9",
    "name": "9-Center of Mass",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pdfPath": "topernotephy9.pdf"
  },
  {
    "id": "topernotephy10",
    "name": "10-Rotational Motion",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pdfPath": "topernotephy10.pdf"
  },
  {
    "id": "topernotephy11",
    "name": "11-Gravitation",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pdfPath": "topernotephy11.pdf"
  },
  {
    "id": "topernotephy12",
    "name": "12-Mechanical properties of Solids",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pdfPath": "topernotephy12.pdf"
  },
  {
    "id": "topernotephy13",
    "name": "13-Mechanical properties of Fluids",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pdfPath": "topernotephy13.pdf"
  },
  {
    "id": "topernotephy14",
    "name": "14-Termal Properties of  Matter",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pdfPath": "topernotephy14.pdf"
  },
  {
    "id": "topernotephy15",
    "name": "15-Thermodynamics",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pdfPath": "topernotephy15.pdf"
  },
  {
    "id": "topernotephy16",
    "name": "16-Simples Harmonic Motion",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pdfPath": "topernotephy16.pdf"
  },
  {
    "id": "topernotephy17",
    "name": "17-Waves",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pdfPath": "topernotephy17.pdf"
  },
  {
    "id": "topernotephy18",
    "name": "18-Electric Charges of Fields",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pdfPath": "topernotephy18.pdf"
  },
  {
    "id": "topernotephy19",
    "name": "19-Electric Potential and Capacitance",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pdfPath": "topernotephy19.pdf"
  },
  {
    "id": "topernotephy20",
    "name": "20-Current Electricity",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pdfPath": "topernotephy20.pdf"
  },
  {
    "id": "topernotephy21",
    "name": "21-Moving Charges & Magnetism",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pdfPath": "topernotephy21.pdf"
  },
  {
    "id": "topernotephy22",
    "name": "22-Magnetism & Matter",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pdfPath": "topernotephy22.pdf"
  },
  {
    "id": "topernotephy23",
    "name": "23-Electromagnetic Induction",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pdfPath": "topernotephy23.pdf"
  },
  {
    "id": "topernotephy24",
    "name": "24-Alternating Current",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pdfPath": "topernotephy24.pdf"
  },
  {
    "id": "topernotephy25",
    "name": "25-Electromagnatic Waves",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pdfPath": "topernotephy25.pdf"
  },
  {
    "id": "topernotephy26",
    "name": "26-Ray Optics",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pdfPath": "topernotephy26.pdf"
  },
  {
    "id": "topernotephy27",
    "name": "27-Wave Optics",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pdfPath": "topernotephy27.pdf"
  },
  {
    "id": "topernotephy28",
    "name": "28-Dual Nature of Radiation of  Matter",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pdfPath": "topernotephy28.pdf"
  },
  {
    "id": "topernotephy29",
    "name": "29-Atoms",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pdfPath": "topernotephy29.pdf"
  },
  {
    "id": "topernotephy30",
    "name": "30-Nuclei",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pdfPath": "topernotephy30.pdf"
  },
  {
    "id": "topernotephy31",
    "name": "31-Semiconductors",
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pdfPath": "topernotephy31.pdf"
  },
  {
    "id": "topernotephy1",
    "name": "1-Mole Concept",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC01",
    "pdfPath": "topernotephy1.pdf"
  },
  {
    "id": "topernotephy2",
    "name": "2-Structure of Atom",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pdfPath": "topernotephy2.pdf"
  },
  {
    "id": "topernotephy3",
    "name": "3-Periodic Table",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pdfPath": "topernotephy3.pdf"
  },
  {
    "id": "topernotephy4",
    "name": "4-Chemical Bonding",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pdfPath": "topernotephy4.pdf"
  },
  {
    "id": "topernotephy5",
    "name": "5-States of Matter",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pdfPath": "topernotephy5.pdf"
  },
  {
    "id": "topernotephy6",
    "name": "6-Thermodynamics",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC06",
    "pdfPath": "topernotephy6.pdf"
  },
  {
    "id": "topernotephy7",
    "name": "7-Chemical Equilibrium",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pdfPath": "topernotephy7.pdf"
  },
  {
    "id": "topernotephy8",
    "name": "8-Ionic Equilibrium",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pdfPath": "topernotephy8.pdf"
  },
  {
    "id": "topernotephy9",
    "name": "9-Hydrogen",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pdfPath": "topernotephy9.pdf"
  },
  {
    "id": "topernotephy10",
    "name": "10-S Block",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pdfPath": "topernotephy10.pdf"
  },
  {
    "id": "topernotephy11",
    "name": "11- P Block",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pdfPath": "topernotephy11.pdf"
  },
  {
    "id": "topernotephy12",
    "name": "12- P Block (G - 15)",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pdfPath": "topernotephy12.pdf"
  },
  {
    "id": "topernotephy13",
    "name": "13-Solid State",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pdfPath": "topernotephy13.pdf"
  },
  {
    "id": "topernotephy14",
    "name": "14-Surface Chemistry",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pdfPath": "topernotephy14.pdf"
  },
  {
    "id": "topernotephy15",
    "name": "15-Enviornmental Chemistry",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pdfPath": "topernotephy15.pdf"
  },
  {
    "id": "topernotephy16",
    "name": "16-Solutions",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pdfPath": "topernotephy16.pdf"
  },
  {
    "id": "topernotephy17",
    "name": "17-Electrochemistry",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pdfPath": "topernotephy17.pdf"
  },
  {
    "id": "topernotephy18",
    "name": "18-Chemical Kinetics",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pdfPath": "topernotephy18.pdf"
  },
  {
    "id": "topernotephy19",
    "name": "19-D and F Block",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pdfPath": "topernotephy19.pdf"
  },
  {
    "id": "topernotephy20",
    "name": "20-Coordination Compound",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pdfPath": "topernotephy20.pdf"
  },
  {
    "id": "topernotephy21",
    "name": "21-Metallurgy",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pdfPath": "topernotephy21.pdf"
  },
  {
    "id": "topernotephy22",
    "name": "22-Haloalkane & Haloarenes",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pdfPath": "topernotephy22.pdf"
  },
  {
    "id": "topernotephy23",
    "name": "23-Alcohol Phenol and Ether",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pdfPath": "topernotephy23.pdf"
  },
  {
    "id": "topernotephy24",
    "name": "24-Aldehyde, Ketone and Carboxylic acid",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pdfPath": "topernotephy24.pdf"
  },
  {
    "id": "topernotephy25",
    "name": "25-Amines",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pdfPath": "topernotephy25.pdf"
  },
  {
    "id": "topernotephy26",
    "name": "26-Biomolecules",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pdfPath": "topernotephy26.pdf"
  },
  {
    "id": "topernotephy27",
    "name": "27-Polymers",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pdfPath": "topernotephy27.pdf"
  },
  {
    "id": "topernotephy28",
    "name": "28-General Organic Chemistry",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pdfPath": "topernotephy28.pdf"
  },
  {
    "id": "topernotephy29",
    "name": "29-Hydrocarbon",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pdfPath": "topernotephy29.pdf"
  },
  {
    "id": "topernotephy30",
    "name": "30-IUPAC Nomenclature",
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pdfPath": "topernotephy30.pdf"
  },
  {
    "id": "topernotebio1",
    "name": "1-Application of Biotechnology",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pdfPath": "topernotebio1.pdf"
  },
  {
    "id": "topernotebio2",
    "name": "2-Animal Diversity",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pdfPath": "topernotebio2.pdf"
  },
  {
    "id": "topernotebio3",
    "name": "3-Animal Husbandry",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pdfPath": "topernotebio3.pdf"
  },
  {
    "id": "topernotebio4",
    "name": "4-Biomolecules",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pdfPath": "topernotebio4.pdf"
  },
  {
    "id": "topernotebio5",
    "name": "5-Biotechnology",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pdfPath": "topernotebio5.pdf"
  },
  {
    "id": "topernotebio6",
    "name": "6-Body fluid and circulation",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pdfPath": "topernotebio6.pdf"
  },
  {
    "id": "topernotebio7",
    "name": "7-Breathing and exchange of gases",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pdfPath": "topernotebio7.pdf"
  },
  {
    "id": "topernotebio8",
    "name": "8-Bigestion and absorption",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pdfPath": "topernotebio8.pdf"
  },
  {
    "id": "topernotebio9",
    "name": "9-Ecosystem",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pdfPath": "topernotebio9.pdf"
  },
  {
    "id": "topernotebio10",
    "name": "10-Environmental issue",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pdfPath": "topernotebio10.pdf"
  },
  {
    "id": "topernotebio11",
    "name": "11-Evolution",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pdfPath": "topernotebio11.pdf"
  },
  {
    "id": "topernotebio12",
    "name": "12-Excretory system",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pdfPath": "topernotebio12.pdf"
  },
  {
    "id": "topernotebio13",
    "name": "13-Human genetics",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pdfPath": "topernotebio13.pdf"
  },
  {
    "id": "topernotebio14",
    "name": "14-Human health and disease",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pdfPath": "topernotebio14.pdf"
  },
  {
    "id": "topernotebio15",
    "name": "15-Human physiology",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pdfPath": "topernotebio15.pdf"
  },
  {
    "id": "topernotebio16",
    "name": "16-Microbesin Human Welfare",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pdfPath": "topernotebio16.pdf"
  },
  {
    "id": "topernotebio17",
    "name": "17-Plant Breeding",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pdfPath": "topernotebio17.pdf"
  },
  {
    "id": "topernotebio18",
    "name": "18-Reproduction",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pdfPath": "topernotebio18.pdf"
  },
  {
    "id": "topernotebio19",
    "name": "19-Reproductive Health",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pdfPath": "topernotebio19.pdf"
  },
  {
    "id": "topernotebio20",
    "name": "20-Structural Organisation",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pdfPath": "topernotebio20.pdf"
  },
  {
    "id": "topernotebio21",
    "name": "21-Genetics",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pdfPath": "topernotebio21.pdf"
  },
  {
    "id": "topernotebio22",
    "name": "22-Organisms and Theri",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pdfPath": "topernotebio22.pdf"
  },
  {
    "id": "topernotebio23",
    "name": "23-Biodiversity",
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pdfPath": "topernotebio23.pdf"
  }








  ]


export default PdfFiles;